"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useYear = exports.YearProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const YEARS = [2026, 2025];
const YearContext = (0, react_1.createContext)(undefined);
const YearProvider = ({ children }) => {
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    // Derive selectedYear directly from URL as single source of truth
    const yearFromParam = Number(searchParams.get("year"));
    const selectedYear = YEARS.includes(yearFromParam) ? yearFromParam : YEARS[0];
    // Wrapper to update year via URL params
    const updateYear = (0, react_1.useCallback)((year) => {
        if (YEARS.includes(year)) {
            const next = new URLSearchParams(searchParams);
            next.set("year", String(year));
            setSearchParams(next, { replace: true });
        }
    }, [searchParams, setSearchParams]);
    return ((0, jsx_runtime_1.jsx)(YearContext.Provider, { value: { years: YEARS, selectedYear, setSelectedYear: updateYear }, children: children }));
};
exports.YearProvider = YearProvider;
const useYear = () => {
    const ctx = (0, react_1.useContext)(YearContext);
    if (!ctx) {
        throw new Error("useYear must be used within a YearProvider");
    }
    return ctx;
};
exports.useYear = useYear;
